'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { DEFAULT_LANGUAGE, LANGUAGE_COOKIE_KEY, LANGUAGE_COOKIE_MAX_AGE, LANGUAGE_LIST, type LanguageType } from '@/shared/localization';
import { useLocale } from 'next-intl';
import { usePathname, useRouter } from 'next/navigation';
export function useLanguage() {
  const $ = _c(6);
  const pathname = usePathname() ?? `/${DEFAULT_LANGUAGE}`;
  const router = useRouter();
  const locale = useLocale();
  let t0;
  if ($[0] !== pathname || $[1] !== router) {
    t0 = newLocale => {
      if (!LANGUAGE_LIST.includes(newLocale as LanguageType)) {
        return;
      }
      document.cookie = `${LANGUAGE_COOKIE_KEY}=${newLocale}; path=/; max-age=${LANGUAGE_COOKIE_MAX_AGE}; SameSite=Lax`;
      document.documentElement.setAttribute("lang", newLocale);
      const newPath = pathname.replace(new RegExp(`^/(${LANGUAGE_LIST.join("|")})`), `/${newLocale}`);
      router.replace(newPath);
      router.refresh();
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setLanguage = t0;
  let t1;
  if ($[3] !== locale || $[4] !== setLanguage) {
    t1 = [locale, setLanguage];
    $[3] = locale;
    $[4] = setLanguage;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}